import React from "react";
import { Typography } from "@material-ui/core";
import { Li, ListItem, StyledTable } from "./Components";

import wcp_haz_lev from "../img/sswpIcons/WorkingCloseToPublic/wcp_haz_lev.png";
import wcp_acc_to_pre from "../img/sswpIcons/WorkingCloseToPublic/wcp_acc_pre.png";
import wcp_bar_fen_hoa from "../img/sswpIcons/WorkingCloseToPublic/wcp_bar_fen_hoa.png";
import wcp_cyc_lan from "../img/sswpIcons/WorkingCloseToPublic/wcp_cyc_lan.png";
import wcp_ped_con from "../img/sswpIcons/WorkingCloseToPublic/wcp_ped_con.png";
import wcp_ped_rou from "../img/sswpIcons/WorkingCloseToPublic/wcp_ped_rou.png";
import wcp_pub_tra from "../img/sswpIcons/WorkingCloseToPublic/wcp_pub_tra_poi.png";
import wcp_sec from "../img/sswpIcons/WorkingCloseToPublic/wcp_sec.png";
import wcp_hou from "../img/sswpIcons/WorkingCloseToPublic/wcp_hou.png";
import wcp_dus_muc_cle_rem from "../img/sswpIcons/WorkingCloseToPublic/wcp_dus_muc_cle.png";
import wcp_vis_con from "../img/sswpIcons/WorkingCloseToPublic/wcp_vis_con.png";
import wcp_han_con from "../img/sswpIcons/WorkingCloseToPublic/wcp_han_con.png";
import wcp_sit_spe_met_sta from "../img/sswpIcons/WorkingCloseToPublic/wcp_sit_spe_met.png";

const json = {
    icon: wcp_haz_lev,
    name: "Working Close To Public",
    text:
        "Where work activity is carried out close to members of the public, measures should be taken to protect them.",
    icons: {
        wcp_bar_fen_hoa: {
            name: "Barriers/ Fencing/ Hoarding",
            icon: wcp_bar_fen_hoa,
            text: (
                <ul>
                    <ListItem text="Barriers must be used around any unattended openings or excavations." />
                    <ListItem text="Barriers should be used to exclude pedestrians from the works site." />
                    <ListItem text="Barriers should be at least 1.0m high and have a high visibility (red/white bar) rail. The bottom rail should be a maximum of 200mm from ground level. Be careful of hazard created by feet." />
                </ul>
            )
        },
        wcp_hou: {
            name: "Housekeeping",
            icon: wcp_hou,
            text: (
                <ul>
                    <ListItem text="Accessways must be kept clear of tools, plant, equipment, materials, rubbish or detritus materials/dirt & muck. Bins need to be provided and used." />
                    <ListItem text="Slip, trip and fall hazards need to be removed." />
                    <ListItem text="Protruding nails, screws or other sharp object need to be removed." />
                    <ListItem text="The storage of tools and materials needs to be organised and all operatives need to store items in their designated place." />
                </ul>
            )
        },
        wcp_ped_rou: {
            name: "Pedestrian Routes/ Crossing Point",
            icon: wcp_ped_rou,
            text: (
                <ul>
                    <ListItem text="Pedestrians will be diverted to the other footway, or a  dedicated pedestrian route will be provided past the works." />
                    <ListItem text="Where there are raised kerbs, ramps should be provided." />
                    <ListItem text="Pedestrians are directed to cross the roadway using the Pedestrian Cross Left, or Pedestrian Cross Right sign as appropriate." />
                    <Li>
                        <Typography variant="title">
                            The visibility to traffic at the crossing point
                            should be assessed as follows
                        </Typography>
                        <StyledTable>
                            <tbody>
                                <tr>
                                    <td>30 km/h</td>
                                    <td>30m per lane to cross</td>
                                </tr>
                                <tr>
                                    <td>50 km/h</td>
                                    <td>45m per lane to cross</td>
                                </tr>
                                <tr>
                                    <td>60 km/h</td>
                                    <td>60m per lane to cross</td>
                                </tr>
                            </tbody>
                        </StyledTable>
                    </Li>
                    <ListItem text="Where this visibility is not achieved consider using the Temporary Pedestrian Crossing sign to warn traffic" />
                    <Li>
                        <Typography variant="title">
                            The widths for pedestrian routes should comply with
                        </Typography>
                        <StyledTable>
                            <tbody>
                                <tr>
                                    <th>Min. Width</th>
                                    <th>Match Existing</th>
                                </tr>
                                <tr>
                                    <td>Allow wheelchair to pass obstacle</td>
                                    <td>1.0m</td>
                                </tr>
                                <tr>
                                    <td>
                                        Allow wheelchair and pedestrian to pass
                                    </td>
                                    <td>1.2m</td>
                                </tr>
                                <tr>
                                    <td>Allow 2 wheelchairs to pass</td>
                                    <td>1.8m</td>
                                </tr>
                                <tr>
                                    <td>Minimum clear headroom</td>
                                    <td>2.3m</td>
                                </tr>
                            </tbody>
                        </StyledTable>
                    </Li>
                </ul>
            )
        },
        wcp_cyc_lan: {
            name: "Cycle Lane/ Shared Running Lane",
            icon: wcp_cyc_lan,
            text: (
                <ul>
                    <ListItem text="Minimum dimension for cycle lane is 1.5m" />
                    <Li>
                        <Typography variant="title">
                            Shared running lane widths for shuttle traffic
                            management
                        </Typography>
                        <ol>
                            <ListItem text="< 3.3m (use WK 086 Cyclist present sign) is existing lane width > 3.3m and length of shuttle is > 50m." />
                            <ListItem text="3.3 – 3.5m can be used without additional controls" />
                            <ListItem text="3.5 – 4.0m should be AVOIDED" />
                            <ListItem text="4.0 – 4.2 can be used without additional controls" />
                            <ListItem text="Use WK 086 cyclist present AND Cycle lane ends sign is closing legal cycle track (it will have solid white line)" />
                        </ol>
                    </Li>
                    <Li>
                        <Typography variant="title">
                            Shared running lane widths for two-way traffic
                        </Typography>
                        <ol>
                            <ListItem text="< 60km/h = 6.0m" />
                            <ListItem text="> 60 km/h = 7.0m" />
                        </ol>
                    </Li>
                </ul>
            )
        },
        wcp_ped_con: {
            name: "Pedestrian Controller",
            icon: wcp_ped_con,
            text: (
                <ul>
                    <ListItem text="An operative on site will be given the role of Pedestrian Controller" />
                    <ListItem text="The pedestrian controller will need to be advised of the risks present (to pedestrians and from traffic), and the necessary controls to be used. This includes how to control the risk from traffic, and what method is to be used to direct pedestrians." />
                    <ListItem text="Generally this method is only suitable for low pedestrian volumes (intermittent or low counts in relation to footway width). Where pedestrians counts are low and intermittent, the pedestrian controller can have other duties, provided they can keep awareness around them of approaching pedestrians. Other than this, the pedestrian controller should be given this as their sole task." />
                    <Li>
                        <Typography variant="title">
                            This role includes
                        </Typography>
                        <ol>
                            <ListItem text="Identifying, within reason, whether a pedestrian will require assistance through/past the work area" />
                            <ListItem text="Offering guidance/assistance to the pedestrian through/past work area." />
                            <ListItem text="Offering guidance/assistance to the pedestrian to cross the roadway, if required." />
                        </ol>
                    </Li>
                    <ListItem text="The pedestrian controller needs to wear clothing/PPE that easily identifies them to the public as a worker associated with the works." />
                </ul>
            )
        },
        wcp_pub_tra_poi: {
            name: "Public Transport Point",
            icon: wcp_pub_tra,
            text: (
                <ul>
                    <ListItem text="The relevant local authority and public transport provider should be notified of the work." />
                    <ListItem text="If possible, an alternative transport access should be provided as close as possible to the exiting point." />
                    <ListItem text="Check for overhead obstructions prior to relocating a bus lane or bus stop from it’s regular location." />
                </ul>
            )
        },
        wcp_acc_pre: {
            name: "Access To Premises",
            icon: wcp_acc_to_pre,
            text: (
                <ul>
                    <ListItem text="Access to business or residential properties may need to be maintained through the use of ramps. These areas should be kept clear and tidy, with appropriate surfaces. Public buildings normally need a minimum ramp width of 1.8m." />
                </ul>
            )
        },
        wcp_dus_muc_cle: {
            name: "Dust/ Muck/ Cleaning & Removal",
            icon: wcp_dus_muc_cle_rem,
            text: (
                <ul>
                    <ListItem text="Dust and muck are a nuisance for workers and the public." />
                    <ListItem text="Hand brushes may be used for smaller areas" />
                    <ListItem text="Equipment of plant should be used for larger areas" />
                    <ListItem text="Heavy soiling will require a cleaning action (with brushes, most surfaces should NOT use steel type brushes)" />
                    <ListItem text="During periods of dry weather, where dust is a problem, the area may be dampened (generally do NOT over wet)" />
                </ul>
            )
        },
        wcp_sec: {
            name: "Security",
            icon: wcp_sec,
            text: (
                <ul>
                    <ListItem text="Security personnel will only allow authorized people onto a site." />
                </ul>
            )
        },
        wcp_vis_con: {
            name: "Visitor Control",
            icon: wcp_vis_con,
            text: (
                <ul>
                    <ListItem text="All visitors must report to a specified point before being allowed to enter the site." />
                    <Li>
                        <Typography variant="title">
                            Visitors must follow these rules
                        </Typography>
                        <ol>
                            <ListItem text="They must register. This should record visitor name, time in, time out and reason for visit/who they are visiting. This should be enforced by Site Staff, i.e. Do NOT rely on visitor complying with signage, or remembering to sign." />
                            <ListItem text="They must wear the required PPE. As a minimum Hard Hats, Protective Toecap boots, Minimum of Class 2 High Viz Top, and any other mandatory PPE in accordance with site rules" />
                            <ListItem text="Visitors MUST be accompanied on site for the duration of their stay. They must comply with instructions, and keep within permitted areas." />
                        </ol>
                    </Li>
                    <ListItem text="During some operations, the risks involved will not allow visitors to be on site. At these times, A clear tagging system/alert system should be used on the visitor register." />
                    <ListItem text="Some sites will require visitors to undergo induction prior to entry. In such cases, the visitor should give written confirmation of such induction (sign register)." />
                </ul>
            )
        },
        wcp_han_con: {
            name: "Handover Controls",
            icon: wcp_han_con,
            text: (
                <ul>
                    <ListItem text="When handing over works areas to clients, adequate controls need to remain in place if your work activity is not complete." />
                    <ListItem text="You should have adequate segregation between your work activity and the client in the form of hoardings, fencing, barriers, or cones." />
                    <ListItem text="There should be separate access routes for your works access and your client access. If this is not possible the appropriate traffic control will be required." />
                </ul>
            )
        },
        wcp_sit_spe_met: {
            name: "Site Specific Method Statement",
            icon: wcp_sit_spe_met_sta,
            text: (
                <ul>
                    <ListItem text="A Site Specific Method Statement/ Design will require the engineer/designer to visit the site to carry out the risk assessment. They will then decide on the appropriate controls. This will generally be the case for High Risk works or sites." />
                    <Li>
                        <Typography variant="title">
                            Generally, the engineer/designer will prepare the
                            following documents for you which you must be
                            familiar with and follow
                        </Typography>
                        <ol>
                            <ListItem text="Risk Assessment and Control Selection." />
                            <ListItem text="Contact details for information or site issues" />
                            <ListItem text="Details on design information, such as equipment lists, spacings, visibility, and scope of application of the design" />
                            <ListItem text="Location map" />
                            <ListItem text="Site specific layouts" />
                            <ListItem text="Method statements, these may be standard type operation procedures, or step by step instructions for each phase of the works." />
                            <ListItem text="Details of inspections to be undertaken, and records to be completed." />
                            <ListItem text="Site induction procedures/ Safe Systems of Works Plans" />
                        </ol>
                    </Li>
                </ul>
            )
        }
    }
};
export default json;
